import { updateValue } from '../../library/siteCookie'

export default ($el) =>
  ({
    dismissed: 'no',
    el: $el,
    init() {
      const toClasses = this.el.dataset.transitionTo ?? null
      const fromClasses = this.el.dataset.transitionFrom ?? null
      const toClassesArray = toClasses ? toClasses.split(' ') : null
      const fromClassesArray = fromClasses ? fromClasses.split(' ') : null
      const delay = this.el.dataset.delay ? this.el.dataset.delay : 3000
      setTimeout(() => {
        if (toClassesArray && toClassesArray.length > 0) {
          this.el.classList.add(...toClassesArray)
        }
        if (fromClassesArray && fromClassesArray.length > 0) {
          this.el.classList.remove(...fromClassesArray)
        }
      }, delay)
    },
    handleClick() {
      this.dismissed = 'yes'
      this.el.classList.add(...['opacity-0', 'pointer-events-none'])
      updateValue('mailingList', this.dismissed)
    },
  })
